/* Bulle (i) "Ajouter une marge de X %" : ouverture / fermeture (Claude, oct. 2026).
   Le theme (assets/sample-button.js) ne fait que basculer .is-active au clic, et la CSS l'affiche aussi au survol :
   la croix (span .mpn-tip-x de snippets/mpn-favoris.liquid) retirait .is-active mais le :hover gardait la bulle ouverte.
   Ici, par delegation (marche aussi si le bloc est re-rendu) : clic sur (i) = bascule, clic sur la croix = ferme
   (meme souris dessus), clic ailleurs / Echap = ferme. .mpn-tip-off bloque le survol jusqu'a la sortie du (i). */
(function () {
  if (window.__mpnCutTip) return; window.__mpnCutTip = true;
  var INFO = '.product__cuttings-info';
  function bubble(el) { return el.querySelector(':scope > span'); }
  function hovered(el) { try { return el.matches(':hover'); } catch (e) { return false; } }
  function close(el) { el.classList.remove('is-active'); if (hovered(el)) el.classList.add('mpn-tip-off'); }
  function closeAll(except) {
    [].forEach.call(document.querySelectorAll(INFO), function (t) { if (t !== except) close(t); });
  }
  window.addEventListener('click', function (e) {
    var t = e.target, el = t && t.closest ? t.closest(INFO) : null;
    if (!el) { closeAll(null); return; }
    /* on garde la main : le gestionnaire du theme ne rebascule pas derriere nous */
    e.stopPropagation();
    if (t.closest('.mpn-tip-x')) { e.preventDefault(); close(el); return; }
    var b = bubble(el);
    if (b && b.contains(t)) return; /* clic dans le texte de la bulle : elle reste ouverte */
    e.preventDefault();
    /* (i) : ouverte par clic -> ferme ; sinon (fermee, ou seulement survolee) -> reste ouverte */
    if (el.classList.contains('is-active')) { close(el); return; }
    closeAll(el);
    [].forEach.call(document.querySelectorAll('[data-tooltip].is-active'), function (t) { t.classList.remove('is-active'); });
    el.classList.remove('mpn-tip-off');
    el.classList.add('is-active');
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll(null);
  });
  /* la souris quitte le (i) et sa bulle : le survol peut a nouveau l'ouvrir */
  document.addEventListener('mouseout', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(INFO) : null;
    if (!el || !el.classList.contains('mpn-tip-off')) return;
    var to = e.relatedTarget;
    if (to && el.contains(to)) return;
    el.classList.remove('mpn-tip-off');
  });
})();
